import defaults from './empresa.json'
import type { EmpresaSettings } from './types'
import { LocalJsonStore } from '../../storage'

const STORAGE_KEY = 'masterhub.settings.empresa'

export class EmpresaRepository {
  private readonly store = new LocalJsonStore<EmpresaSettings>(
    STORAGE_KEY,
    defaults as EmpresaSettings,
  )

  get(): EmpresaSettings {
    return this.store.load()
  }

  save(value: EmpresaSettings): boolean {
    return this.store.save(value)
  }

  reset(): EmpresaSettings {
    return this.store.reset()
  }
}

export const empresaRepository = new EmpresaRepository()
